// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button svg[data-v-018e64c8]{width:48px;height:48px}@media (max-width:1536px){button svg[data-v-018e64c8]{width:40px;height:40px}}", ""]);
// Exports
module.exports = exports;
